(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PfAuthnWidget", [], factory);
	else if(typeof exports === 'object')
		exports["PfAuthnWidget"] = factory();
	else
		root["PfAuthnWidget"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 